import { render } from "./DashboardLink.vue?vue&type=template&id=5d1836a5&scoped=true"
import script from "./DashboardLink.vue?vue&type=script&lang=js"
export * from "./DashboardLink.vue?vue&type=script&lang=js"

import "./DashboardLink.vue?vue&type=style&index=0&id=5d1836a5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1836a5"]])

export default __exports__